import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface PaperCounterState {
  totalPaperUsed: number
  incrementPrinted: (copies: number) => void
  reset: () => void
}

export const usePaperCounterStore = create<PaperCounterState>()(
  persist(
    (set) => ({
      totalPaperUsed: 0,

      incrementPrinted: (copies: number): void => {
        if (!Number.isFinite(copies) || copies <= 0) return
        const safeCopies = Math.round(copies)
        set((state) => ({
          totalPaperUsed: state.totalPaperUsed + safeCopies
        }))
      },

      reset: (): void => { set({ totalPaperUsed: 0 }) }
    }),
    {
      name: 'paper-counter-storage'
    }
  )
)
